module.exports = __webpack_public_path__ + "static/img/br_stomach.859d7f67.webp";